import { eventBus } from '../../foundation/eventBus';
import { zenNavEvents as menuEvents, zenNavSelectors as selectors, zenNavElements } from './zen-nav-header';
var burgerMenu = document.getElementById('zen-burger-menu');

export const zenNavMenu = () => {
    
    const elementDisabled = (element) => element.ariaDisabled !== null ?  (element.ariaDisabled === "true") : false;
    const isOpenSubmenuLink = (element) => element.ariaHasPopup !== null ? (element.ariaHasPopup === "true"): false;
    
    /* prevent overlaying panel propogating events to undelying banner */
    const handleBackPanelOverlayingBanner = () => elements.bannerLink.setAttribute('aria-disabled', true);
    const handleBackLinkClick = () => elements.bannerLink.setAttribute('aria-disabled', false);

    const elements = zenNavElements();
    
    const handleMenuClosed = () => {
        const { navOpen: openSelector, navMenuOpen} = selectors;
        elements.menuHeader.classList.remove(openSelector);
        elements.menu.classList.remove(openSelector);
        elements.navMenu.classList.remove(navMenuOpen);
        elements.navVeil.classList.remove(openSelector);
        elements.subNavMenu.classList.remove(selectors.subNavOpen);
        burgerMenu.setAttribute('aria-expanded', false);
        burgerMenu.focus();
    }
    const handleBannerClick = (banner) => {
        const bannerEnabled = !elementDisabled(elements.bannerLink);
        
        if (!isOpenSubmenuLink(banner) && !bannerEnabled){
            handleBackLinkClick();
        }
        if (bannerEnabled) {
            location.href = banner.getAttribute('data-login-url');
        }
    }
    const menuClick = (event) => {
        if (isOpenSubmenuLink(event.target)){
            handleBackPanelOverlayingBanner();
        }
        if (event.target.id == selectors.bannerLink) {
            if (elements.bannerLink.classList.contains('loggedin')){
                event.preventDefault();
            }
            handleBannerClick(event.target);
        }
    }
    const closeBurgerMenu = (event) => {
        if (elements.menu.classList.contains(selectors.navOpen)) {
            if (event.keyCode == 27) {
                handleMenuClosed();
                document.removeEventListener("keydown", closeBurgerMenu)
            }
        }
    }
    const init = component => {
        eventBus.subscribe(menuEvents.openMenu, () => {
            component.addEventListener('click', handleMenuClosed);
            elements.navVeil.addEventListener('click', handleMenuClosed);
            elements.menu.addEventListener('click', menuClick);
            document.addEventListener("keydown", closeBurgerMenu);
        });
    };
    
    return {
        init: init,
        selector: '.zen-nav-menu-header-mobile__close-button',
        handleMenuClosed: handleMenuClosed
    };
}